import {
  arrowLeftCircleColor,
  arrowLeftCircleFilledColor,
  arrowRightCircleColor,
  arrowRightCircleFilledColor,
  close,
  closeBold,
  informationCircle,
  newTabBold,
  positionBold,
  removeCircle,
  search,
  searchColor,
  warningTriangle,
  zoomIn,
  zoomOut,
} from '@elvia/elvis-assets-icons';
import { addIcons } from '@elvia/elvis-icons';

addIcons({
  arrowLeftCircleColor: { svg: arrowLeftCircleColor.getIcon() },
  arrowLeftCircleFilledColor: { svg: arrowLeftCircleFilledColor.getIcon() },
  arrowRightCircleColor: { svg: arrowRightCircleColor.getIcon() },
  arrowRightCircleFilledColor: { svg: arrowRightCircleFilledColor.getIcon() },
  close: { svg: close.getIcon() },
  closeBold: { svg: closeBold.getIcon() },
  informationCircle: { svg: informationCircle.getIcon() },
  newTabBold: { svg: newTabBold.getIcon() },
  positionBold: { svg: positionBold.getIcon() },
  removeCircle: { svg: removeCircle.getIcon() },
  search: { svg: search.getIcon() },
  searchColor: { svg: searchColor.getIcon() },
  warningTriangle: { svg: warningTriangle.getIcon() },
  zoomIn: { svg: zoomIn.getIcon() },
  zoomOut: { svg: zoomOut.getIcon() },
});
